import * as React from "react";

function SvgComponent(
  props: JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>
) {
  return (
    <svg
      width={20}
      height={20}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.675 7.32a1.126 1.126 0 00-1.572 0L10 10.365 6.897 7.32a1.126 1.126 0 00-1.572 0 1.077 1.077 0 000 1.543l3.89 3.818a1.126 1.126 0 001.57 0l3.89-3.818a1.077 1.077 0 000-1.543z"
        fill={props.color ?? "#23262F"}
      />
    </svg>
  );
}

export default SvgComponent;
